import {CommonModule} from '@angular/common';
import {MaterialModule} from '../../../../material/material.module';
import {NgModule} from '@angular/core';
import {SecondStepComponent} from './second-step.component';

@NgModule({
  declarations: [SecondStepComponent],
  exports: [SecondStepComponent],
  imports: [
    CommonModule,
    MaterialModule
  ]
})

export class SecondStepModule {
}
